import {Grid2, Skeleton} from '@mui/material';

const ChangeWalletSkeleton = () => (
  <Grid2
    container
    sx={{
      overflow: 'hidden',
      overflowX: 'scroll',
      flexWrap: 'nowrap',
      marginTop: '4px',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      pr: 2,
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }}
    rowSpacing={1}
    columnSpacing={1}>
    {[...Array(4)].map((_, index) => (
      <Grid2
        display={'flex'}
        flexDirection={'column'}
        sx={{
          backgroundColor: 'background.paper',
          p: '10px',
          borderRadius: '10px',
          minWidth: '115px',
        }}
        key={index}>
        <Grid2
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            height: '120px',
            justifyContent: 'center',
          }}>
          <Skeleton
            variant="rectangular"
            width={'100%'}
            height={'85px'}
            sx={{borderRadius: '8px'}}
          />
          <Skeleton variant="text" width={60} height={10} sx={{mt: '5px'}} />
          <Skeleton variant="text" width={40} height={7} />
        </Grid2>
        <Grid2 size={12} display={'flex'} justifyContent={'center'}>
          <Skeleton
            variant="text"
            width={66}
            height={20}
            sx={{borderRadius: '5px'}}
          />
        </Grid2>
      </Grid2>
    ))}
  </Grid2>
);

export default ChangeWalletSkeleton;
